<div class="page-content">

  <div class="row">
    <div class="col-lg-12 progress-top-level centered">
      <h1><span translate>SCHEDULE_INTERVIEW.BANNER</span><span class="text-capitalize">{{service}}</span></h1>
      <p class="divider hidden-xs"></p>
    </div>
  </div>

  <progress-tracker></progress-tracker>

  <div class="container">

    <router-outlet></router-outlet>

    <div class="row-button-group d-flex flex-column flex-md-row">

      <div class="col-12 col-md-4 col-lg-3 order-1 order-md-2 ms-auto">
        <div class="col-12">
          <div class="col-12 text-right">
            <i>{{nextCaption | translate}}</i>
          </div>
          @if (inReview && stepNo === 4) {
            <button id="submitAppointment" class="btn btn-nav btn-primary w-100 d-block" type="submit" (click)="submitAppointment()" (keyup.enter)="submitAppointment()">
              <span translate>GENERAL_REUSABLE.BUTTON_LABEL.SUBMIT</span>
              <i class="fa fa-check"></i>
            </button>
          }
          @if (inReview && stepNo === 3) {
            <button id="btnDoneViewing" class="btn btn-nav btn-primary w-100 d-block" type="button" (click)="cancel()" (keyup.enter)="cancel()">
              <span translate>GENERAL_REUSABLE.BUTTON_LABEL.DONE</span>
              <i class="fa fa-check"></i>
            </button>
          }
        </div>
      </div>

      @if (canGoBack()) {
        <div class="col-12 col-md-6 order-2 order-md-1">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
              <button id="back" class="btn btn-default btn-nav" name="back" (click)="goBack()" tabindex="0" (keyup.enter)="goBack()">
                <i class="fa fa-chevron-left"></i>
                <span translate>GENERAL_REUSABLE.BUTTON_LABEL.BACK_BUTTON</span>
              </button>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <button id="cancel" class="btn btn-default btn-nav" name="cancel" (click)="cancel()" tabindex="0" (keyup.enter)="cancel()">
                <span translate>GENERAL_REUSABLE.BUTTON_LABEL.CANCEL</span>
              </button>
            </div>
          </div>
        </div>
      }
      @if (!canGoBack()) {
        <div class="col-12 col-md-4 col-lg-2 order-2 order-md-1">
          <button id="cancel" class="btn btn-default btn-nav" name="cancel" (click)="cancel()" tabindex="0" (keyup.enter)="cancel()">
            <span translate>GENERAL_REUSABLE.BUTTON_LABEL.CANCEL</span>
          </button>
        </div>
      }


    </div>
  </div>
</div>